import { render, staticRenderFns } from "./PageEntregaChip.vue?vue&type=template&id=42a2233a&"
import script from "./PageEntregaChip.vue?vue&type=script&lang=js&"
export * from "./PageEntregaChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports